import React from "react";
import LegalPage from "./LegalPage";
import { BRAND } from "@/constants/content";

const PrivacyPolicy = () => (
  <LegalPage
    title="Privacy Policy"
    description="How BoostF collects, uses, and protects your personal information."
  >
    <p>
      At {BRAND.name}, we take your privacy seriously. This Privacy Policy explains what
      information we collect when you use our website and register for the {BRAND.tagline},
      how we use it, and the choices you have.
    </p>

    <h2>1. Information we collect</h2>
    <ul>
      <li>Contact information you submit (name, email, WhatsApp number) when reserving a seat.</li>
      <li>Payment information handled and processed by Razorpay (we do not store card details).</li>
      <li>Basic analytics data such as pages visited, device type, and referring URL.</li>
    </ul>

    <h2>2. How we use your information</h2>
    <ul>
      <li>To send you your registration confirmation, joining instructions, and community invites.</li>
      <li>To share updates related to the marathon and future BoostF programs.</li>
      <li>To improve our website, offering, and support experience.</li>
    </ul>

    <h2>3. Sharing</h2>
    <p>
      We do not sell your personal information. We only share data with trusted service
      providers required to run the marathon — such as our payment processor (Razorpay) and
      our transactional email provider — and only to the extent necessary.
    </p>

    <h2>4. Data retention</h2>
    <p>
      We retain your registration data for as long as needed to provide the marathon and
      comply with any applicable legal obligations.
    </p>

    <h2>5. Your rights</h2>
    <p>
      You may request access to, correction of, or deletion of your personal data at any
      time by writing to us at {BRAND.supportEmail}.
    </p>

    <h2>6. Updates</h2>
    <p>
      We may update this policy from time to time. The latest version will always be
      available on this page.
    </p>
  </LegalPage>
);

export default PrivacyPolicy;
